module.exports = __webpack_public_path__ + "static/img/e-banner3.a109f9b8.jpg";